import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M9.933 1.277h-5.11a2.684 2.684 0 0 0-2.68 2.67v8.18a2.684 2.684 0 0 0 2.68 2.67h6.35a2.678 2.678 0 0 0 2.68-2.67V5.2Zm2.42 10.85a1.18 1.18 0 0 1-1.18 1.17h-6.35a1.18 1.18 0 0 1-1.18-1.17v-8.18a1.18 1.18 0 0 1 1.18-1.17h4.43v3.11h3.1Zm-1.36-.31a.749.749 0 0 1-.75.75h-4.48a.75.75 0 1 1 0-1.5h4.48a.755.755 0 0 1 .75.75Zm-.33-4.22-1.4 1.88a1.538 1.538 0 0 1-.12.13.767.767 0 0 1-.31.16.881.881 0 0 1-.17.02.767.767 0 0 1-.44-.14l-.01-.01-.73-.52-.96 1.28a.757.757 0 0 1-.61.3.731.731 0 0 1-.44-.15.758.758 0 0 1-.16-1.05l1.4-1.87a.769.769 0 0 1 .12-.13.784.784 0 0 1 .15-.1.764.764 0 0 1 .33-.08.672.672 0 0 1 .24.04.75.75 0 0 1 .2.1l.01.01.73.52.96-1.28a.751.751 0 0 1 1.21.89Z';
const draw24px =
  'M16,15.09H8a.75.75,0,0,1,0-1.5h8a.75.75,0,0,1,0,1.5ZM14.75,18a.76.76,0,0,0-.75-.75H8a.75.75,0,0,0,0,1.5h6A.76.76,0,0,0,14.75,18ZM20.7,5.63V18.37A3.76,3.76,0,0,1,17,22.12H7a3.76,3.76,0,0,1-3.75-3.75V5.63A3.76,3.76,0,0,1,7,1.88H17A3.76,3.76,0,0,1,20.7,5.63Zm-1.5,0A2.25,2.25,0,0,0,17,3.38H7A2.25,2.25,0,0,0,4.75,5.63V18.37A2.25,2.25,0,0,0,7,20.62H17a2.25,2.25,0,0,0,2.25-2.25ZM16.12,5.4a.75.75,0,0,0-1.05.15L13,8.33,11.22,7h0a.74.74,0,0,0-.83,0,.24.24,0,0,0-.09.06.8.8,0,0,0-.13.13h0L7.67,10.54a.74.74,0,0,0,.16,1.05.74.74,0,0,0,1-.15l2.06-2.77,1.75,1.27.05,0a.72.72,0,0,0,.44.14.74.74,0,0,0,.61-.31v0l2.48-3.33A.75.75,0,0,0,16.12,5.4Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const DocumentReportIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'documentReport')) as IconWithRender;

DocumentReportIcon.displayName = 'DocumentReportIcon';
DocumentReportIcon.propTypes = Icon.propTypes;
DocumentReportIcon.renderIcon = (props) => <DocumentReportIcon {...props} />;
export default DocumentReportIcon;
